import React, {useState} from 'react';
import project_example from "../images/Product Card.png";
import project_location from "../images/project_location.svg";
import {motion} from "framer-motion";

const ProjectCard = ({animation, custom}) => {

    const [isExpanded, setIsExpanded] = useState(false);
    const toggleDescription = () => {
        setIsExpanded(!isExpanded);
    };
    const descClasses = `project_desc ${isExpanded ? 'expanded' : ''}`;
    return (
        <motion.div className = "project_card" {...animation} custom = {custom}>
            <div className = "project_image">
                <img src = {project_example} alt = ""/>
            </div>
            <div className = "project_info">
                <div className = "project_location">
                    <img src = {project_location} alt = ""/>
                    Talin, Estonia
                </div>
                <div className = "project_info_main">
                    <div className = "project_name">
                        SafeUa Foundation
                    </div>
                    <div className={descClasses} onClick={toggleDescription}>
                        SafeUa Foundation is a non-profit charitable organization
                        dedicated to ensuring the safety, protection, and comprehensive
                        support of affected citizens of Ukraine.
                        Our mission is to restore a sense of security and provide necessary
                        assistance to those whose lives have been disrupted by the conflict.
                        We strive to be a reliable shield (as symbolized by our logo) for Ukrainians,
                        creating a space where safety and support are paramount.
                    </div>
                </div>
                <div className = "visit_project_site">
                    Visit site
                </div>
            </div>
        </motion.div>
    );
};

export default ProjectCard;